import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, mergeProps as _mergeProps, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "sz-white--text font-weight-bold mt-1 text-wrap-balance text-h5"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "f-18 font-weight-regular sz-primary-grey--text mb-0" }
const _hoisted_6 = { class: "font-italic" }
const _hoisted_7 = { class: "f-16 font-weight-medium sz-primary-red--text mb-0" }
const _hoisted_8 = ["id", "href"]
const _hoisted_9 = { class: "d-none d-md-inline" }
const _hoisted_10 = { class: "d-inline d-md-none" }
const _hoisted_11 = ["id", "href"]
const _hoisted_12 = { class: "d-none d-md-inline" }
const _hoisted_13 = { class: "d-inline d-md-none" }
const _hoisted_14 = { class: "ml-2" }

import InactiveProvinceModal from '@/components/Home/InactiveProvinceModal.vue';
import LogoComponent from '@/components/widgets/LogoComponent.vue';
import { LINKS } from '@/constants/externalLinks';
import { useTidio } from '@/stores/Tidio';
import getLangsVariable from '@/utils/getLangsVariable';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useDisplay, useGoTo } from 'vuetify';
import { useStore } from 'vuex';
import useEditionStageStore from '@/stores/EditionStage';
import { EditionStage } from '@/types/backend';

type Props = {
  showScrollDown?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeHero',
  props: {
    showScrollDown: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n();
const goTo = useGoTo();
const store = useStore();
const router = useRouter();
const route = useRoute();

const { mdAndUp, smAndUp } = useDisplay();

const selectedProvinceId = ref(null);
const szpPaymentLink = ref(LINKS.szpPaymentFormMain);
const selectedInactiveProvince = ref(null);

const autocomplete = ref(null);
const heroImage = ref(null);
const inactiveProvinceModal = ref(null);

const editionStageStore = useEditionStageStore();
const {
    isBeforeCampaign,
    isAfterCampaign,
    isBetweenCampaign,
    isCampaignUnderway
} = storeToRefs(editionStageStore);

const provincesList = computed(() => store.getters['provinces/getProvinces']);
const bubblesLoader = computed(() => store.getters['bubbles/getLoader']);
const provincesLoader = computed(() => store.getters['provinces/getLoader']);
const currentProvinceName = computed(() => {
    const province = provincesList.value.find(el => el.province_id === selectedProvinceId.value);
    return province ? province.province_name : '';
});
const isSelectVisible = computed(() => isCampaignUnderway.value);
const gtmTitle = computed(() => getLangsVariable(['HOME_PAGE', 'title']));

const donateButtonId = computed(() => {
    if (isBeforeCampaign.value) {
        return 'swr-step0-payment-before-start-button';
    } else if (isAfterCampaign.value) {
        return 'swr-step0-payment-after-final-button';
    } else if (isBetweenCampaign.value) {
        return 'swr-step0-payment-between-campaign-button';
    }

    return false;
});
const stateTitle = computed(() => {
    if (isBeforeCampaign.value) {
        return t('home.beforeTitle');
    } else if (isAfterCampaign.value) {
        return t('home.afterTitle');
    } else if (isBetweenCampaign.value) {
        return t('home.betweenTitle');
    }

    return t('home.title');
});
const stateSubtitle = computed(() => {
    if (isBeforeCampaign.value) {
        return t('home.beforeSubtitle');
    } else if (isAfterCampaign.value) {
        return t('home.afterSubtitle');
    } else if (isBetweenCampaign.value) {
        return t('home.betweenSubtitle');
    }

    return t('home.subtitle');
});

const heroTitle = computed(() => gtmTitle.value || stateTitle.value);

const waitingFamilies = computed(() => {
    if (Number.isNaN(familiesAmount.value)) return '';
    let value = familiesAmount.value;
    if (getLangsVariable(['HOME_PAGE', 'familiesAmount'])) {
        value = parseInt(getLangsVariable(['HOME_PAGE', 'familiesAmount'])) - helpedFamiliesAmount.value;
    }
    if (getLangsVariable(['HOME_PAGE', 'waitingFamilies'])) {
        return getLangsVariable(['HOME_PAGE', 'waitingFamilies']).replace('{counter}', value);
    }
    return t('home.waiting_families', value);
});
const familiesAmount = computed(() => store.getters['provinces/getFamiliesAmount']);
const helpedFamiliesAmount = computed(() => store.getters['provinces/getFamiliesHelpedAmount']);
const maxHeightMenu = computed(() => (smAndUp.value ? 300 : 150));

watch(selectedProvinceId, (value) => {
    store.commit('bubbles/setBubbles', null);
    if (value) {
        store.commit('provinces/setCurrentProvinceId', value);
        store.dispatch('bubbles/getBubbles', value);
        autocomplete.value.blur();
    }
});

watch(currentProvinceName, (val) => {
    const newProvince = val || undefined;
    store.commit('provinces/setCurrentProvinceName', newProvince);
    const currentRouteName = router.currentRoute.name;
    if (router.currentRoute.query?.province === val) return;
    router.replace({ name: currentRouteName, query: { province: newProvince } });
});

watch(route, () => {
    setFilterFromQuery();
});

const tidioStore = useTidio();
const { isDisplayChat, isHideChatOnClose, isTidioChatEnabledBasedOnEditionStage } = storeToRefs(tidioStore);

const changeTidioVisibilitySettingsOnProvinceChoose = (): void => {
    if (!isTidioChatEnabledBasedOnEditionStage.value) return;
    if (route.query?.province) {
        isDisplayChat.value = true;
        isHideChatOnClose.value = false;
    } else {
        isDisplayChat.value = false;
        isHideChatOnClose.value = false;
    }
    tidioStore.setChatVisibilityBasedOnRefs();
};

watch(route, () => {
    changeTidioVisibilitySettingsOnProvinceChoose();
}, { immediate: true });

onMounted(() => {
    if (getLangsVariable(['HOME_PAGE', 'heroImageUrl'])) {
        heroImage.value.style.background = `url('${getLangsVariable(['HOME_PAGE', 'heroImageUrl'])}')`;
    }
    if (!selectedProvinceId.value) selectedProvinceId.value = store.getters['provinces/getCurrentProvinceId'];

    setFilterFromQuery();
});

function scrollToInfo () {
    goTo('#firstInfoContainer', {
        offset: 48,
        easing: 'easeInQuad'
    });
}

function showInactiveProvinceModal (provinceItem) {
    selectedInactiveProvince.value = provinceItem;
    selectedProvinceId.value = null;
    autocomplete.value.blur();
    inactiveProvinceModal.value.open();
}

function setFilterFromQuery () {
    const { query } = route;
    const selectedProvince = provincesList.value?.find((province) => province?.province_name === query?.province);
    if (selectedProvince?.active === false) showInactiveProvinceModal(selectedProvince);
    else selectedProvinceId.value = selectedProvince?.province_id;
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_orphans = _resolveDirective("orphans")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "heroImage",
    ref: heroImage,
    class: _normalizeClass(["home-hero", [{ 'home-hero-between': _unref(isBetweenCampaign) }, { 'home-hero-after': _unref(isAfterCampaign) }]])
  }, [
    _createVNode(_component_v_container, { class: "fill-height" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          justify: "end",
          align: "end",
          class: "fill-height"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "fill-height d-flex align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "start",
                  justify: "start",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "3",
                      sm: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(LogoComponent)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "9",
                      sm: "10",
                      class: "px-3 d-flex align-self-center"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("h1", {
                          class: _normalizeClass(["mb-0 sz-white--text font-weight-medium", [isSelectVisible.value ? 'text-h2' : 'text-h3']]),
                          innerHTML: heroTitle.value
                        }, null, 10, _hoisted_1), [
                          [_directive_orphans]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "10",
                      class: "offset-sm-2 px-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "10",
                          lg: "9",
                          xl: "8",
                          class: "mt-0 pl-0"
                        }, {
                          default: _withCtx(() => [
                            (stateSubtitle.value)
                              ? _withDirectives((_openBlock(), _createElementBlock("h4", {
                                  key: 0,
                                  class: _normalizeClass(["mb-0 sz-white--text font-weight-medium text-wrap-balance", [{ 'f-20': !isSelectVisible.value }, { 'text-h4': isSelectVisible.value },
                           { 'bg-text-dark-shadow': _unref(isAfterCampaign) }]]),
                                  innerHTML: stateSubtitle.value
                                }, null, 10, _hoisted_2)), [
                                  [_directive_orphans]
                                ])
                              : _createCommentVNode("", true),
                            (_unref(isBeforeCampaign))
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString(_ctx.$t('home.heroFloodInfo')), 1))
                              : _createCommentVNode("", true),
                            (_unref(isBeforeCampaign))
                              ? _withDirectives((_openBlock(), _createElementBlock("h4", {
                                  key: 2,
                                  class: _normalizeClass(["mb-0 sz-white--text font-weight-medium text-wrap-balance", [isSelectVisible.value ? 'text-h4' : 'f-20']]),
                                  innerHTML: _ctx.$t('home.beforeSubtitle2')
                                }, null, 10, _hoisted_4)), [
                                  [_directive_orphans]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (isSelectVisible.value)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12",
                              sm: "9",
                              md: "6",
                              class: "mt-0 sz-white pa-6 rounded-block"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  align: "center",
                                  justify: "start",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('home.choose_province')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_autocomplete, {
                                          ref_key: "autocomplete",
                                          ref: autocomplete,
                                          modelValue: selectedProvinceId.value,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedProvinceId).value = $event)),
                                          autocomplete: "off",
                                          label: _ctx.$t('label.choose_province'),
                                          items: provincesList.value,
                                          "item-value": "province_id",
                                          "item-title": "province_name",
                                          class: "home-hero__autocomplete sz-primary-grey--text mt-0",
                                          color: "szGrey",
                                          "menu-props": {
                        closeOnClick: true,
                        closeOnContentClick: true,
                        maxHeight: maxHeightMenu.value
                      },
                                          "single-line": "",
                                          "hide-details": "",
                                          loading: bubblesLoader.value || provincesLoader.value,
                                          "auto-select-first": "",
                                          "menu-icon": "$expand"
                                        }, {
                                          item: _withCtx(({ item, props }) => [
                                            (item.raw.active)
                                              ? (_openBlock(), _createBlock(_component_v_list_item, _normalizeProps(_mergeProps({ key: 0 }, props)), {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, { class: "f-16" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.province_name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1040))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createVNode(_component_v_list_item, {
                                                    class: "text-disabled d-none d-sm-flex",
                                                    onClick: _withModifiers(($event: any) => (showInactiveProvinceModal(item.raw)), ["stop"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, { class: "f-16" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(props.title) + " ", 1),
                                                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "px-2" }, "|", -1)),
                                                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('home.noFamilies')), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _createVNode(_component_v_list_item, _mergeProps(props, {
                                                    class: "text-disabled d-block d-sm-none",
                                                    onClick: _withModifiers(($event: any) => (showInactiveProvinceModal(item.raw)), ["stop"])
                                                  }), {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, { class: "f-16" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.province_name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_list_item_subtitle, { class: "f-12 font-italic" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.$t('home.noFamilies')), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1040, ["onClick"])
                                                ], 64))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "label", "items", "menu-props", "loading"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          justify: "center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "px-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [
                                                  _createTextVNode(_toDisplayString(waitingFamilies.value), 1)
                                                ])), [
                                                  [_directive_orphans]
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_unref(isBetweenCampaign))
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                class: "pl-0",
                                cols: "auto"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    wrap: "",
                                    "no-gutters": "",
                                    jusify: "center",
                                    align: "center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "auto",
                                        class: _normalizeClass({ 'pr-5': _unref(mdAndUp) })
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("a", {
                                            id: donateButtonId.value,
                                            class: "d-block text-center d-md-inline-block primary-button f-16 font-weight-medium",
                                            href: szpPaymentLink.value,
                                            target: "_blank"
                                          }, [
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('label.donateForSzp')), 1),
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('label.donateToHelp')), 1)
                                          ], 8, _hoisted_8)
                                        ]),
                                        _: 1
                                      }, 8, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                class: "pl-0",
                                cols: "auto",
                                "align-self": "center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    id: donateButtonId.value,
                                    class: "d-block text-center d-sm-inline-block primary-button f-16 font-weight-medium",
                                    href: szpPaymentLink.value,
                                    target: "_blank"
                                  }, [
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('label.donateForSzp')), 1),
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('label.donateToHelp')), 1)
                                  ], 8, _hoisted_11)
                                ]),
                                _: 1
                              }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.showScrollDown)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12",
                  class: "home-hero__scroll-down mb-0 pb-0 text-center font-weight-regular"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "sz-white--text f-14 mb-0 disable-text-decoration",
                      onClick: scrollToInfo
                    }, [
                      _createVNode(_component_v_btn, {
                        height: "36",
                        width: "36",
                        class: "text-szLightGrey f-14",
                        color: "white",
                        icon: "$arrowDown",
                        variant: "flat"
                      }),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('home.scrollDown')), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(InactiveProvinceModal, {
      ref_key: "inactiveProvinceModal",
      ref: inactiveProvinceModal,
      province: selectedInactiveProvince.value
    }, null, 8, ["province"])
  ], 2))
}
}

})